<h1 class="areaHeading pt-5 pb-2 mt-5">Projects</h1>

<div *ngFor="let project of _projects; let index = index">
    <app-summary [project]="project" [index]="index" (ViewDetailsEvent)="showDetails($event)"></app-summary>
</div>

<div class="mt-3 d-block text-center custom collapsed" style="cursor: pointer;" data-toggle="collapse" href="#collapseProjects" aria-expanded="false"
    aria-controls="collapseProjects">
    <p class="mb-0" style="font-size: large; font-weight: 500;">
        <span class="more">
            View More
        </span>
        <span class="less">
            View Less
        </span>
    </p>
    <mat-icon>expand_more</mat-icon>
</div>

<div class="collapse" id="collapseProjects">
    <div class="row">
        <div class="col-md-6 col-lg-4 mt-3" *ngFor="let project of projects | async">
            <mat-card class="example-card px-3 py-4">
                <mat-card-header>
                    <mat-card-title>
                        <span class="txt-primary">
                            {{ project.title }}
                        </span>
                    </mat-card-title>
                    <mat-card-subtitle class="mb-0">
                        <span class="txt-words" style="text-overflow: ellipsis;">
                            {{ project.shortDescription }}
                        </span>
                        <span style="display: block; font-weight: 500; margin-top: 2px;">
                            {{ project.year }}
                        </span>
                    </mat-card-subtitle>
                </mat-card-header>
                <div class="p-2">
                    <img mat-card-image [src]="project.imgSrc" [alt]="project.title">
                </div>
                <mat-card-content>
                    <span (click)="showDetails(project.id)" aria-label="Read More" class="read_more">
                        Read more <mat-icon>double_arrow</mat-icon>
                    </span>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
